var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesterdayShift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.183,
    height: 125.436,
    viewBox: "0 0 137.183 125.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6093",
    "data-name": "Group 6093",
    transform: "translate(-1438 -210.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8180",
    "data-name": "Path 8180",
    d: "M115.6,57.8A57.8,57.8,0,1,1,57.8,0a57.8,57.8,0,0,1,57.8,57.8",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8181",
    "data-name": "Path 8181",
    d: "M66.811,86.338c10.43-4.208,19.9-11.207,26.037-20.63,7.132-10.943,9.286-24.215,8.661-37.416A52.74,52.74,0,0,0,12.19,84.281c16.925,8,37.211,9.077,54.621,2.054",
    transform: "translate(1438 220.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8182",
    "data-name": "Path 8182",
    d: "M101.509,28.287c.625,13.2-1.529,26.473-8.661,37.417-6.141,9.423-15.607,16.422-26.037,20.629-17.41,7.024-37.7,5.948-54.622-2.054a52.739,52.739,0,1,0,91.193-53q-.887-1.524-1.873-2.988",
    transform: "translate(1438 220.383)",
    fill: "#e9e9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8183",
    "data-name": "Path 8183",
    d: "M57.223,58.48,32.413,36.363,58.377,57.117Z",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8184",
    "data-name": "Path 8184",
    d: "M58.789,57.172,70.239,99.2,56.813,58.423Z",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8185",
    "data-name": "Path 8185",
    d: "M61.705,57.8A3.907,3.907,0,1,1,57.8,53.891,3.907,3.907,0,0,1,61.705,57.8",
    transform: "translate(1438 220.383)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8186",
    "data-name": "Path 8186",
    d: "M57.8,17a.732.732,0,0,1-.732-.732V5.063a.732.732,0,1,1,1.464,0v11.21A.732.732,0,0,1,57.8,17",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8187",
    "data-name": "Path 8187",
    d: "M57.8,111.264a.732.732,0,0,1-.732-.732V99.322a.732.732,0,1,1,1.464,0v11.21a.732.732,0,0,1-.732.732",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8188",
    "data-name": "Path 8188",
    d: "M110.532,58.53H99.322a.733.733,0,1,1,0-1.465h11.21a.733.733,0,1,1,0,1.465",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8189",
    "data-name": "Path 8189",
    d: "M16.273,58.53H5.063a.733.733,0,0,1,0-1.465h11.21a.733.733,0,0,1,0,1.465",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8190",
    "data-name": "Path 8190",
    d: "M22.748,36.261a.725.725,0,0,1-.392-.114l-9.462-6.011a.732.732,0,0,1,.785-1.236l9.462,6.011a.732.732,0,0,1-.393,1.351",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8191",
    "data-name": "Path 8191",
    d: "M102.309,86.807a.725.725,0,0,1-.392-.114l-9.462-6.011a.732.732,0,0,1,.785-1.236l9.462,6.011a.732.732,0,0,1-.393,1.35",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8192",
    "data-name": "Path 8192",
    d: "M80.064,23.481a.733.733,0,0,1-.618-1.125l6.011-9.462a.732.732,0,0,1,1.236.785l-6.011,9.462a.732.732,0,0,1-.619.34",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8193",
    "data-name": "Path 8193",
    d: "M29.52,103.042a.733.733,0,0,1-.617-1.125l6.011-9.462a.732.732,0,1,1,1.236.785L30.139,102.7a.732.732,0,0,1-.619.339",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8194",
    "data-name": "Path 8194",
    d: "M92.848,36.261a.732.732,0,0,1-.393-1.351l9.462-6.011a.732.732,0,0,1,.785,1.236L93.24,36.146a.725.725,0,0,1-.392.114",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8195",
    "data-name": "Path 8195",
    d: "M13.287,86.807a.732.732,0,0,1-.393-1.35l9.462-6.011a.732.732,0,0,1,.785,1.236l-9.462,6.011a.725.725,0,0,1-.392.114",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8196",
    "data-name": "Path 8196",
    d: "M35.533,23.481a.732.732,0,0,1-.619-.34L28.9,13.679a.732.732,0,1,1,1.236-.785l6.011,9.462a.733.733,0,0,1-.617,1.125",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8197",
    "data-name": "Path 8197",
    d: "M86.076,103.042a.732.732,0,0,1-.619-.339l-6.011-9.462a.732.732,0,1,1,1.236-.785l6.011,9.462a.732.732,0,0,1-.617,1.125",
    transform: "translate(1438 220.383)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2008",
    "data-name": "Rectangle 2008",
    width: 115.6,
    height: 115.6,
    transform: "translate(1438 220.383)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2004",
    "data-name": "Rectangle 2004",
    width: 62.885,
    height: 48.751,
    transform: "translate(1527.159 290.698) rotate(-104.718)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2005",
    "data-name": "Rectangle 2005",
    width: 62.884,
    height: 48.751,
    transform: "translate(1528.032 290.469) rotate(-104.718)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2006",
    "data-name": "Rectangle 2006",
    width: 53.139,
    height: 40.767,
    transform: "matrix(-0.254, -0.967, 0.967, -0.254, 1530.964, 285.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8158",
    "data-name": "Path 8158",
    d: "M47.687,3.467,33.482.114a4.244,4.244,0,0,0-5.1,3.155l-.559,2.368,22.466,5.3.559-2.368a4.244,4.244,0,0,0-3.155-5.1",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8159",
    "data-name": "Path 8159",
    d: "M27.243,19.785a3.919,3.919,0,1,1-2.914-4.715,3.918,3.918,0,0,1,2.914,4.715",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#e9e9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8160",
    "data-name": "Path 8160",
    d: "M23.238,20.482a.6.6,0,0,1-.514-.286l-1.638-2.65a.6.6,0,1,1,1.026-.634l1.32,2.137,4.2-2.594a.6.6,0,1,1,.634,1.026l-4.711,2.911a.6.6,0,0,1-.316.09",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8161",
    "data-name": "Path 8161",
    d: "M52.66,23.873a.593.593,0,0,1-.139-.016l-21.595-5.1a.6.6,0,0,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8162",
    "data-name": "Path 8162",
    d: "M52.1,26.257a.593.593,0,0,1-.139-.016l-21.6-5.1a.6.6,0,0,1,.277-1.174l21.6,5.1a.6.6,0,0,1-.138,1.19",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8163",
    "data-name": "Path 8163",
    d: "M51.534,28.642a.593.593,0,0,1-.139-.016L29.8,23.526a.6.6,0,0,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8164",
    "data-name": "Path 8164",
    d: "M24.376,31.93a3.919,3.919,0,1,1-2.914-4.715,3.918,3.918,0,0,1,2.914,4.715h0",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#e9e9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8165",
    "data-name": "Path 8165",
    d: "M20.37,32.627a.585.585,0,0,1-.138-.016.6.6,0,0,1-.375-.27l-1.638-2.65a.6.6,0,0,1,1.026-.634l1.32,2.137,4.2-2.595a.6.6,0,0,1,.634,1.026l-4.711,2.912a.6.6,0,0,1-.317.09",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8166",
    "data-name": "Path 8166",
    d: "M49.795,36.017A.593.593,0,0,1,49.656,36l-21.6-5.1a.6.6,0,0,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8167",
    "data-name": "Path 8167",
    d: "M49.231,38.4a.593.593,0,0,1-.139-.016l-21.6-5.1a.6.6,0,0,1,.277-1.174l21.6,5.1a.6.6,0,0,1-.138,1.19",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8168",
    "data-name": "Path 8168",
    d: "M48.667,40.786a.593.593,0,0,1-.139-.016l-21.595-5.1A.6.6,0,1,1,27.21,34.5L48.8,39.6a.6.6,0,0,1-.138,1.19",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8169",
    "data-name": "Path 8169",
    d: "M21.509,44.075a3.919,3.919,0,1,1-2.914-4.715,3.918,3.918,0,0,1,2.914,4.715",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#e9e9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8170",
    "data-name": "Path 8170",
    d: "M17.5,44.773a.585.585,0,0,1-.138-.016.6.6,0,0,1-.375-.27l-1.638-2.65a.6.6,0,1,1,1.026-.634L17.7,43.34l4.2-2.595a.6.6,0,1,1,.634,1.026l-4.711,2.912a.6.6,0,0,1-.317.09",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8171",
    "data-name": "Path 8171",
    d: "M46.927,48.162a.593.593,0,0,1-.139-.016l-21.6-5.1a.6.6,0,1,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8172",
    "data-name": "Path 8172",
    d: "M46.364,50.546a.593.593,0,0,1-.139-.016L24.63,45.43a.6.6,0,1,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8173",
    "data-name": "Path 8173",
    d: "M45.8,52.932a.593.593,0,0,1-.139-.016l-21.595-5.1a.6.6,0,1,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8174",
    "data-name": "Path 8174",
    d: "M52.836,15.31,23.578,8.4A1.716,1.716,0,0,1,22.3,6.34h0l.448-1.9,32.6,7.7-.448,1.9a1.716,1.716,0,0,1-2.064,1.276h0",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#132735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8175",
    "data-name": "Path 8175",
    d: "M18.731,56.241a3.919,3.919,0,1,1-2.914-4.715,3.918,3.918,0,0,1,2.914,4.715h0",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#e9e9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8176",
    "data-name": "Path 8176",
    d: "M14.726,56.934a.6.6,0,0,1-.514-.286L12.574,54a.6.6,0,0,1,1.026-.634L14.921,55.5l4.2-2.595a.6.6,0,0,1,.634,1.026l-4.711,2.912a.6.6,0,0,1-.316.09",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8177",
    "data-name": "Path 8177",
    d: "M44.152,60.327a.593.593,0,0,1-.139-.016l-21.595-5.1a.6.6,0,1,1,.277-1.175l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8178",
    "data-name": "Path 8178",
    d: "M43.587,62.711a.593.593,0,0,1-.139-.016L21.853,57.6a.6.6,0,1,1,.277-1.174l21.595,5.1a.6.6,0,0,1-.138,1.19",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8179",
    "data-name": "Path 8179",
    d: "M43.024,65.1a.593.593,0,0,1-.139-.016l-21.595-5.1a.6.6,0,1,1,.277-1.174l21.6,5.1a.6.6,0,0,1-.138,1.19",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1497.262, 234.47)",
    fill: "#229180"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesterdayShift);
export default __webpack_public_path__ + "static/media/yesterdayShift.c0d4160c7c285170b117d3542b190517.svg";
export { ForwardRef as ReactComponent };